// extracted by mini-css-extract-plugin
export default {"button":"ForgottenPasswordSetNewPassword_button__VgGap","space":"ForgottenPasswordSetNewPassword_space__ZDEnt"};